import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChangeControlRoutingModule } from './change-control-routing.module';
import { LabelComponent } from '../shared-components/label/label.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, ChangeControlRoutingModule, LabelComponent],
})
export class ChangeControlModule {}
